/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Asset,
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetProjectLink
 */
export interface AssetProjectLink {
    /**
     * 
     * @type {number}
     * @memberof AssetProjectLink
     */
    id: number;
    /**
     * 
     * @type {Asset}
     * @memberof AssetProjectLink
     */
    project: Asset;
    /**
     * 
     * @type {string}
     * @memberof AssetProjectLink
     */
    sequenceName: string;
    /**
     * 
     * @type {number}
     * @memberof AssetProjectLink
     */
    asset: number;
}

export function AssetProjectLinkFromJSON(json: any): AssetProjectLink {
    return AssetProjectLinkFromJSONTyped(json, false);
}

export function AssetProjectLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetProjectLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'project': AssetFromJSON(json['project']),
        'sequenceName': json['sequence_name'],
        'asset': json['asset'],
    };
}

export function AssetProjectLinkToJSON(value?: AssetProjectLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'project': AssetToJSON(value.project),
        'sequence_name': value.sequenceName,
        'asset': value.asset,
    };
}


